export const getDemoDataResult = (
  value: string,
  workflowInput: number,
  locale: string,
): string | null => {
  let customInstructions = null
  const data = {
    '12500': {
      en:
        'Sow ID: 12500\n' +
        'Age: 3y6m\n' +
        'Farrowings: 4\n' +
        'Abortions: -\n' +
        'Rep.failures: 1\n' +
        '\n' +
        'Days after weaning: 12\n' +
        'Stimulation: -  \n' +
        'Insemination: 17 hours ago',
      ru:
        'Номер СМ: 12500\n' +
        'Возраст: 3г6м\n' +
        'Кол-во опоросов: 4\n' +
        'Кол-во абортов: -\n' +
        'Кол-во прохолостов: 1\n' +
        '\n' +
        'Дней после отъема: 12\n' +
        'Стимуляция: -   \n' +
        'Осеменение: 17 часов назад',
    },
    '15000': {
      en:
        'Sow ID: 15000\n' +
        'Age: 5y6m\n' +
        'Farrowings: 7\n' +
        'Abortions: 2\n' +
        'Rep.failures: 2\n' +
        '\n' +
        'Days after weaning: 15\n' +
        'Stimulation: PG600 (2 days ago)   \n' +
        'Insemination: -',
      ru:
        'Номер СМ: 15000\n' +
        'Возраст: 5г6м\n' +
        'Кол-во опоросов: 7\n' +
        'Кол-во абортов: 2\n' +
        'Кол-во прохолостов: 2\n' +
        '\n' +
        'Дней после отъема: 15\n' +
        'Стимуляция: PG600 (2 дня назад)   \n' +
        'Осеменение: -',
    },
  }
  if (
    workflowInput === 132045 &&
    value &&
    data[value as keyof typeof data] !== undefined
  ) {
    const val = data[value as keyof typeof data]
    customInstructions = val[locale as keyof typeof val] ?? val.en
  }

  const data2 = {
    F105: {
      en:
        'MORTALITY: \n' +
        'Flock: Actual (Diff. vs. Target) \n' +
        'Current (C): 4.7% (-0.3)\n' +
        'Previous (C-1): 7.0% (0.0)\n' +
        'C-2: 8.5% (+1.5)\n' +
        'C-3: 9.0% (+2.0)\n' +
        'C-4: 9.5% (+2.5)\n' +
        'C-5: 12.0% (+5.0)\n' +
        '\n' +
        'HISTORICAL DISEASES:\n' +
        'Cocci on weeks 4-5, footpads.\n' +
        '\n' +
        'CURRENT DISEASES & TREATMENTS:\n' +
        'Cocci on week 25. Sulmet, Vitamin D',
    },
  }

  if (
    workflowInput === 179805 &&
    value &&
    data2[value as keyof typeof data2] !== undefined
  ) {
    const val = data2[value as keyof typeof data2]
    customInstructions = val[locale as keyof typeof val] ?? val.en
  }

  const data3 = {
    TR01057: {
      en:
        '<b>Order: 12623</b> \n' +
        'Deliver to: FROST \n' +
        'Compartments: 1, 2 \n' +
        '\n' +
        '<b>Order: 12624</b> \n' +
        'Deliver to: Brent Hilbers \n' +
        'Compartments: 3, 4, 5 \n' +
        '\n' +
        '<b>Empty Compartments: 6<b>',
    },
    TR12345: {
      en:
        '<b>Order: 12684</b> \n' +
        'Deliver to: Steve Meyer \n' +
        'Compartments: 3, 4, 5 \n' +
        '\n' +
        '<b>Empty Compartments: 1, 2, 6<b>',
    },
  }

  if (
    workflowInput === 274576 &&
    value &&
    data3[value as keyof typeof data3] !== undefined
  ) {
    const val = data3[value as keyof typeof data3]
    customInstructions = val[locale as keyof typeof val] ?? val.en
  }

  const data4 = {
    '12623': {
      en: 'Compartments: 1, 2, 3\nto Bins: 2, 4, 5',
    },
    '12630': {
      en: 'Compartments: 5, 6\nto Bins: 12',
    },
  }

  if (
    workflowInput === 274582 &&
    value &&
    data4[value as keyof typeof data4] !== undefined
  ) {
    const val = data4[value as keyof typeof data4]
    customInstructions = val[locale as keyof typeof val] ?? val.en
  }

  return customInstructions
}
